module.exports = __webpack_public_path__ + "img/texture.671e24e9.svg";